<style lang="scss" scoped>
@import '~@/abstracts/_variables.scss';

.cancel-scenario-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.cancel-scenario-modal {
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    max-width: 500px;
    width: 90%;
    margin: 20px;
}

.cancel-scenario-modal-content {
    padding: 30px;
    text-align: center;

    h3 {
        font-family: 'Raleway', sans-serif;
        font-size: 24px;
        font-weight: bold;
        color: $regular-blue-color;
        margin-bottom: 15px;
        margin-top: 0;
    }

    p {
        font-family: 'Raleway', sans-serif;
        font-size: 16px;
        color: #666666;
        line-height: 1.5;
        margin-bottom: 25px;
    }
}

.cancel-scenario-modal-buttons {
    display: flex;
    gap: 15px;
    justify-content: center;
    flex-wrap: wrap;
}

.cancel-scenario-modal-button {
    border: none;
    border-radius: 5px;
    padding: 12px 25px;
    font-family: 'Raleway', sans-serif;
    font-size: 15px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 160px;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    &.primary {
        background-color: $secondary-color;
        color: white;

        &:hover:not(:disabled) {
            background-color: #810050;
        }
    }

    &.secondary {
        background-color: transparent;
        color: #666666;
        border: 2px solid #ccc;

        &:hover:not(:disabled) {
            background-color: #f5f5f5;
            border-color: #999;
            color: #333;
        }
    }
}

@media screen and (max-width: 39.9375em) {
    .cancel-scenario-modal {
        max-width: 350px;
    }

    .cancel-scenario-modal-content {
        padding: 25px 20px;

        h3 {
            font-size: 20px;
        }

        p {
            font-size: 14px;
        }
    }

    .cancel-scenario-modal-buttons {
        flex-direction: column;
        gap: 10px;
    }

    .cancel-scenario-modal-button {
        padding: 12px 20px;
        font-size: 14px;
        min-width: unset;
        width: 100%;
    }
}
</style>

<template>
    <div v-if="show" class="cancel-scenario-modal-overlay">
        <div class="cancel-scenario-modal" @click.stop>
            <div class="cancel-scenario-modal-content">
                <h3 v-if="!orderSelfServiceClicked">{{ $t('cancelscenario.label') }}</h3>
                <h3 v-else>{{ $t('cancelscenario.labelSelfService') }}</h3>

                <p v-if="!orderSelfServiceClicked">{{ $t('cancelscenario.text') }}</p>
                <p v-else>{{ $t('cancelscenario.textSelfService') }}</p>

                <svg v-if="orderSelfServiceClicked" viewBox="0 0 24 24" width="64" height="64" aria-hidden="true">
                    <circle cx="12" cy="12" r="10" fill="#22c55e"/>
                    <path d="M8.5 12.5l2.2 2.2 4.8-6" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                <div class="cancel-scenario-modal-buttons" v-if="!orderSelfServiceClicked">
                    <button @click="handleOrderService" class="cancel-scenario-modal-button primary" :disabled="loading">
                        <span>{{ $t('cancelscenario.buttonOrderService') }}</span>
                    </button>

                    <button @click="handleSelfService" class="cancel-scenario-modal-button secondary" :disabled="loading">
                        <span>{{ $t('cancelscenario.buttonSelfService') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from "../../api/service";

export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        cancelToken: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            loading: false,
            orderSelfServiceClicked: false
        }
    },

    methods: {
        async handleSelfService() {
            this.loading = true;

            try {
                const response = await API.cancelScenario(this.cancelToken);

                if (response.status === 200) {
                    this.orderSelfServiceClicked = true;

                    setTimeout(() => {
                        this.$emit('close-modal');
                    }, 10000);
                }
            } catch (error) {
                console.error(error);

                this.orderSelfServiceClicked = true;

                setTimeout(() => {
                    this.$emit('close-modal');
                }, 10000);
            } finally {
                this.loading = false;
            }
        },

        handleOrderService() {
            this.$emit('close-modal');
        }
    }
}
</script>
